import { handleActions } from 'redux-actions';

import checkPermissions from '../../../shared/check-permissions';
import endpoints from '../../../../config/endpoints';
import http from '../../../shared/http';

const namespace = 'offerLangRulesList';

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;
const DELETE_RULE = `${namespace}/delete-rule`;

// initial state
const initialState = {
	data: null,
	isLoading: true,
	isError: false
};

// actions
export const actions = {
	own: {
		fetchData: () => (dispatch, getState) => {
			request(getRequestQuery(), FETCH_DATA_SUCCESS)(dispatch);
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR }),

		remove: (lang) => (dispatch, getState) => {
			const request = http({
				url: endpoints.LANG_RULES.SINGLE.replace('{lang}', lang),
				method: 'delete',
				actions: [DELETE_RULE, FETCH_DATA_ERROR]
			});

			return request(dispatch).then((action) => {
				if (action.type === DELETE_RULE) {
					dispatch(actions.own.fetchData());
				}
			});
		}
	}
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: action.payload.data.map((item) => ({ ...item, id: item.campaign_lang })),
			isLoading: false,
			isError: false
		}),
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		})
	}
);

export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field],
	getCan: (state) => checkPermissions(state, { delete: 'offers_create' })
};

function getRequestQuery() {
	return {};
}

function request(query, successActionType) {
	return http({
		url: endpoints.LANG_RULES.BASE,
		method: 'get',
		actions: [successActionType, FETCH_DATA_ERROR],
		query
	});
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/offer-location-rules/lang-rules/list/index.js